"use client";

import { c as _c } from "react/compiler-runtime";
import { CircularProgress, InputAdornment, TextField, type TextFieldProps } from "@mui/material";
import React, { useEffect, useState } from "react";
type DebouncedInputProps = Omit<TextFieldProps, "onChange"> & {
  value: string;
  onChange: (value: string) => void;
  timeout?: number;
};
export const DebouncedInput: React.FC<DebouncedInputProps> = t0 => {
  const $ = _c(30);
  let InputProps;
  let inputRef;
  let onChange;
  let restProps;
  let timeout;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onChange,
      timeout,
      InputProps,
      inputRef,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = InputProps;
    $[2] = inputRef;
    $[3] = onChange;
    $[4] = restProps;
    $[5] = timeout;
    $[6] = value;
  } else {
    InputProps = $[1];
    inputRef = $[2];
    onChange = $[3];
    restProps = $[4];
    timeout = $[5];
    value = $[6];
  }
  const [rawInput, setRawInput] = useState(value);
  const [hasPendingChanges, setHasPendingChanges] = useState(false);
  const [syncedExternalValue, setSyncedExternalValue] = useState(value);
  if (value !== syncedExternalValue) {
    setSyncedExternalValue(value);
    if (!hasPendingChanges) {
      setRawInput(value);
    }
  }
  let t1;
  if ($[7] !== onChange || $[8] !== rawInput || $[9] !== timeout || $[10] !== value) {
    t1 = () => {
      const timeoutId = setTimeout(() => {
        setHasPendingChanges(false);
        if (rawInput === value) {
          return;
        }
        onChange(rawInput);
      }, timeout ?? 500);
      return () => {
        clearTimeout(timeoutId);
      };
    };
    $[7] = onChange;
    $[8] = rawInput;
    $[9] = timeout;
    $[10] = value;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== onChange || $[13] !== rawInput || $[14] !== restProps.error || $[15] !== timeout || $[16] !== value) {
    t2 = [onChange, rawInput, restProps.error, timeout, value];
    $[12] = onChange;
    $[13] = rawInput;
    $[14] = restProps.error;
    $[15] = timeout;
    $[16] = value;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  useEffect(t1, t2);
  let t3;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ev => {
      setRawInput(ev.target.value);
      setHasPendingChanges(true);
    };
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  const handleChange = t3;
  let t4;
  if ($[19] !== InputProps?.endAdornment || $[20] !== hasPendingChanges) {
    t4 = hasPendingChanges ? <InputAdornment position="end"><CircularProgress size={24} /></InputAdornment> : InputProps?.endAdornment ?? null;
    $[19] = InputProps?.endAdornment;
    $[20] = hasPendingChanges;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== InputProps || $[23] !== t4) {
    t5 = {
      ...InputProps,
      endAdornment: t4
    };
    $[22] = InputProps;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== inputRef || $[26] !== rawInput || $[27] !== restProps || $[28] !== t5) {
    t6 = <TextField value={rawInput} onChange={handleChange} inputRef={inputRef} InputProps={t5} {...restProps} />;
    $[25] = inputRef;
    $[26] = rawInput;
    $[27] = restProps;
    $[28] = t5;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  return t6;
};